// The user's preference for the single-column median beat layout. Persisted
// to localStorage so it survives page reloads and recording switches; the
// slice seeds `settings.medianBeatSingleColumn` from here and writes back on
// every `setMedianBeatSingleColumn`.
const STORAGE_KEY = "annotatorMedianBeatSingleColumn"
const DEFAULT_VALUE = false

export const getPersistedMedianBeatSingleColumn = () => {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY)
        if (raw == null) return DEFAULT_VALUE
        return raw === "true"
    } catch {
        return DEFAULT_VALUE
    }
}

export const setPersistedMedianBeatSingleColumn = (value) => {
    try {
        window.localStorage.setItem(STORAGE_KEY, String(!!value))
    } catch {
        // localStorage can throw (private browsing, quota) — safe to ignore;
        // the in-memory Redux value is still authoritative for this session.
    }
}
